<template>
  <sign-in class="saml-choose-account">
    <template v-if="candidates.length > 0">
      <h1 class="_title">
        {{ $t('samlChooseAccount.title') }}
      </h1>
      <saml-account-chooser
        :candidates="candidates"
        :email="email"
        @select="select"
      />
    </template>
    <template v-else>
      <m-alert type="error">
        {{ $t('samlChooseAccount.invalid') }}
      </m-alert>
      <m-btn
        block
        class="_home-btn"
        @click="goHome"
      >
        {{ $t('samlChooseAccount.backToLogin') }}
      </m-btn>
    </template>
  </sign-in>
</template>

<script setup>
import SamlAccountChooser from '@/components/SamlAccountChooser.vue';
import SignIn from '@/components/SignIn.vue';
import { computed } from 'vue';
import { decodeSamlCandidates } from '@/lib/saml';
import { encodeURLValues } from '@/lib/url';
import { getSentinelUrl } from '@/api/sentinel';
import { useRoute, useRouter } from 'vue-router';

const route = useRoute();
const router = useRouter();

const email = computed(() => route.query.email ?? route.query.samlEmail ?? '');

const candidates = computed(() => decodeSamlCandidates(route.query.candidates));

const select = (slug) => {
  if (route.query.flow === 'msteams') {
    const params = {
      samlEmail: email.value,
      slug,
      provider: route.query.provider ?? '',
      loginHint: route.query.loginHint ?? '',
      tenant: route.query.tenant ?? '',
    };
    window.location.href = getSentinelUrl(`/msteams/auth?${encodeURLValues(params)}`);
    return;
  }

  const params = { email: email.value, slug };
  if (route.query.flow === 'popup') {
    params.flow = 'popup';
    if (route.query.reauth === '1') {
      params.reauth = '1';
    }
  }
  window.location.href = getSentinelUrl(`/saml/login?${encodeURLValues(params)}`);
};

const goHome = () => {
  router.push('/');
};
</script>

<style scoped lang="scss" type="text/scss">
  .saml-choose-account {
    ._title {
      margin: 0 0 1.2rem;
      font-size: $font-size-8;
      font-weight: $font-weight-bold;
      color: $font-color-primary;
    }

    ._home-btn {
      margin-top: 1.6rem;
    }
  }
</style>
